<template>
  <div class="info-popover-container position-relative d-inline-block">
    <info_icon_blau></info_icon_blau>

    <div class="info-popover-box position-absolute ps-4 pe-3 py-3">
        <div class="pb-2"><strong>Hinweis</strong></div>
        Möchten Sie eine minderjährige Person versichern? Dann tragen Sie hier  bitte zuerst die Daten des volljährigen Antragsstellers  /Versicherungsnehmers ein (z.B. ein Elternteil). Die minderjährige  Person kann auf der Folgeseite unter der Rubrik „zu versichernde  Personen“ eingetragen werden.
    </div>
  </div>
</template>

<script setup>
import info_icon_blau from '@/components/icons/info_icon_blau.vue';
</script>